import GeoLocation from './GeoLocation';
import ContactInfo from './ContactInfo';
import { ClientInput } from 'src/services/graphql/Models';
import { DataClass } from 'src/shared/utility';

export default class Client implements ClientInput, DataClass {
  clientId: string;
  typedId: string;
  name: string;
  icon?: string | null;
  brief?: string | null;
  location?: GeoLocation | null;
  contacts: Array< ContactInfo >;
  
  constructor ( from: any ) { 
    this.clientId = from.clientId;
    this.typedId = from.typedId;
    this.name = from.name;
    this.icon = from.icon;
    this.brief = from.brief;
    this.location = new GeoLocation(from.location);
    this.contacts = (from.contacts || []).map(o => new ContactInfo(o));
  }
  
  parseAbsolute() {
    return {
      clientId: this.clientId,
      typedId: this.typedId,
      name: this.name,
      icon: this.icon,
      brief: this.brief,
      location: this.location.parseAbsolute(),
      contacts: (this.contacts || []).map(o => o.parseAbsolute())
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Client.ts